module.exports = __webpack_public_path__ + "static/img/143.df60fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/143.png
// module id = pdQo
// module chunks = 0